import _extends from "@babel/runtime/helpers/esm/extends";
import React, { forwardRef } from 'react';
import { StyledPhotoCarouselKeyboardInstructions } from './PhotoCarouselKeyboardInstructions.styles';

/**
 * A badge that appears when a Property Card Photo Carousel gets focus.
 * It informs users that they can navigate the carousel using their keyboards.
 *
 * @since 8.66.0
 */
export var PhotoCarouselKeyboardInstructions = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  return /*#__PURE__*/React.createElement(StyledPhotoCarouselKeyboardInstructions, _extends({
    ref: forwardedRef
  }, props));
});
PhotoCarouselKeyboardInstructions.displayName = 'PropertyCard.KeyboardInstructions';